import React, { Component } from 'react';
import ErrorMessage from '../common/ErrorMessage';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import poweredLogo from '../../img/powered-by-logo.png';
import CircularProgress from '@material-ui/core/CircularProgress';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Input from '@material-ui/core/Input';
import FormHelperText from '@material-ui/core/FormHelperText';

const styles = {
  main: {
    maxWidth: '400px',
    minWidth: '250px',
  },
  paper: {
    marginTop: '50px',
    padding: '60px 30px ',
  },
  header: {
    fontWeight: '300',
    fontSize: '20px',
    marginBottom: '0',
    marginTop: '0',
  },
  logo: {
    width: '200px',
    paddingTop: '15px',
  },
  paragraph: {
    fontSize: '15px',
    marginBottom: '0',
  },
  button: {
    margin: '30px 10px',
    display: 'inline-block',
  },
  bottom: {
    marginTop: '20px',
  },
};

class Username extends Component {
  renderErrors(errors) {
    if (errors) {
      if (Array.isArray(errors)) {
        return errors.map((error, i) => <ErrorMessage key={i} error={error} />);
      } else {
        return <ErrorMessage error={errors} />;
      }
    }
  }

  render() {
    const {
      errors,
      currentlySending,
      loading,
      username,
      errorUsername,
      handleSubmit,
      handleUsernameChange,
      logo,
    } = this.props;

    return (
      <div className="col-xs-10 col-sm-6 col-md-4 col-lg-4" style={styles.main}>
        <div className="box">
          <Paper elevation={3} style={styles.paper}>
            <form action="#" method="POST" onSubmit={handleSubmit}>
              <div className="row center-xs">
                <div className="col-xs-12">
                  <div className="box">{logo()}</div>
                </div>
                <div className="col-sm-10 col-xs-11">
                  <div className="box">
                    <h2>Forgot Password?</h2>
                    <p>Please enter your username to send verification SMS text message.</p>
                  </div>
                </div>
                <div className="col-xs-12">
                  <div className="box">
                    {currentlySending || loading ? (
                      <CircularProgress size={25} thickness={3} />
                    ) : (
                      this.renderErrors(errors)
                    )}
                  </div>
                </div>
                <div className="col-sm-10 col-xs-11">
                  <div className="box" style={{ margin: '10px 0 10px' }}>
                    <FormControl
                      fullWidth
                      error={errorUsername ? true : false}
                      aria-describedby="username"
                    >
                      <InputLabel shrink htmlFor="username-label">
                        Username
                      </InputLabel>
                      <Input
                        autoComplete="off"
                        id="username"
                        value={username}
                        onChange={handleUsernameChange}
                      />
                      <FormHelperText id="username-error-text">{errorUsername}</FormHelperText>
                    </FormControl>
                  </div>
                </div>
                <div className="col-xs-12">
                  <div className="box">
                    <Button
                      variant="contained"
                      type="submit"
                      id="submit-button"
                      style={styles.button}
                      color="primary"
                      disabled={currentlySending || loading ? true : false}
                    >
                      Submit
                    </Button>
                  </div>
                </div>
              </div>
            </form>
          </Paper>
          <a href="http://defisolutions.com" target="_blank" rel="noopener noreferrer">
            <img src={poweredLogo} style={styles.bottom} alt="logo" />
          </a>
        </div>
      </div>
    );
  }
}

export default Username;
